export function formHandling(){

    const checkInputValue = (_inp) => {
        if (_inp.value) {
            _inp.parentElement.classList.add("form-item-active");
        } else {
            _inp.parentElement.classList.remove("form-item-active");
        }
    }

    document.querySelectorAll(".gfield--type-text input").forEach((_inp) => {
        const parentDiv = _inp.closest(".gfield");
    
        _inp.addEventListener("focus", () => {
        parentDiv.classList.add("gfield--active");
        });
    
        _inp.addEventListener("blur", () => {
        parentDiv.classList.remove("gfield--active");
        checkInputValue(_inp);
        });
    
        checkInputValue(_inp);
    });
        

    document.querySelectorAll(".gfield--type-email input[type='email']").forEach((_inp) => {
    const parentEmailDiv = _inp.closest(".gfield") || _inp.closest(".ginput_container");

    _inp.addEventListener("focus", () => {
        parentEmailDiv.classList.add("gfield--active");
    });

    _inp.addEventListener("blur", () => {
        parentEmailDiv.classList.remove("gfield--active");
        checkInputValue(_inp);
    });

    checkInputValue(_inp);
    });

}